export enum ResourceRecurrenceEnum {
  RECURRENT = 'RECURRENT',
  EXCEPTIONAL = 'EXCEPTIONAL',
}
